<template>
  <div class="sr-only" role="status">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/a11y";

// This component is visually hidden but still accessible to screen readers
// eg. aria-live 'search results count' region
.sr-only {
  @include a11y.screen-reader-only;
}
</style>
